import { jsx as _jsx } from "react/jsx-runtime";
import { RICH_TEXT_TYPES } from '../../types';
import LegalSup from '../Legal/LegalSup/LegalSup';
import { isLegal, isDrawer, isOneTrustPreferences, getLegalEntries } from '../Legal/utils';
import EmbeddedDrawer from './embeddedDrawer';
import EmbeddedOneTrustLink from './embeddedOneTrustLink';
var INLINES = RICH_TEXT_TYPES.INLINES;
export var buildEmbeddedInlineEntryFunction = function (_a) {
    var _b;
    var EmbeddedInlineComponent = _a.EmbeddedInlineComponent, content = _a.content, legalSizing = _a.legalSizing;
    var legalCount = -1;
    var headingSize = legalSizing.headingSize, paragraphSize = legalSizing.paragraphSize;
    // creates a list of unique legal entries with correct font size and comma placement
    var allLegals = getLegalEntries(content, {
        headingSize: headingSize,
        paragraphSize: paragraphSize
    });
    return _b = {},
        _b[INLINES.EMBEDDED_ENTRY] = function (node, children) {
            var _a, _b;
            // legal inline items
            if (isLegal(node)) {
                legalCount += 1;
                return (_jsx(LegalSup, { node: node, addComma: (_a = allLegals[legalCount]) === null || _a === void 0 ? void 0 : _a.addComma, fontSize: (_b = allLegals[legalCount]) === null || _b === void 0 ? void 0 : _b.size }));
            }
            // drawer inline items
            if (isDrawer(node)) {
                return _jsx(EmbeddedDrawer, { node: node, paragraphSize: paragraphSize });
            }
            // drawer inline items
            if (isOneTrustPreferences(node)) {
                return _jsx(EmbeddedOneTrustLink, { node: node });
            }
            return EmbeddedInlineComponent !== null && EmbeddedInlineComponent !== void 0 ? EmbeddedInlineComponent : children;
        },
        _b;
};
